import { Component, Input, OnInit } from '@angular/core';
import * as fromUserPromotions from '@app/client/account/team/promotion/reducers/promotion.reducer';
import * as fromRoot from '@app/reducers';
import { Promotion } from '@app/shared/models/promotion';
import { DialogRef } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { UserPromotionActions } from '../../actions';


@Component({
  selector: 'app-modal-confirm',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss']
})
export class ModalConfirmComponent implements OnInit {

  processing$: Observable<boolean>;
  promotionUpdated$: Observable<boolean>;

  promotion: Promotion;
  @Input() confirmTitle: string;
  @Input() confirmHint: string;
  @Input() confirmButton: string;
  @Input() confirmProcessing: string;

  constructor(
    private readonly store$: Store<fromRoot.State & fromUserPromotions.State>,
    public ref: DialogRef,
  ) {
    this.processing$ = this.store$.select(fromUserPromotions.getPromotionProcessing);
    this.promotionUpdated$ = this.store$.select(fromUserPromotions.getPromotionUpdated);
    this.promotionUpdated$.pipe(first(updated => updated)).subscribe(() => this.closeModal());
  }

  ngOnInit() { }

  confirmAction() {
    this.store$.dispatch(UserPromotionActions.updatePromotion());
  }

  closeModal() {
    this.ref.close();
  }
}
